import { useStore } from 'vuex';

import authApi from '@/modules/auth/api/authApi';
import utils from '@/utils/utils';

import { useLoading } from 'vue-loading-overlay';

const useRoles = () => {
    const store = useStore();
    const $loading = useLoading();

    const cabecera = () => ({
        headers: {
            'Content-type': 'application/json',
            'Authorization': 'Bearer ' + store.getters['auth/getToken'],
        }
    });

    const obtenerRoles = async (nombre: string) => {
        const respuesta = {
            ok: false,
            data: undefined as any,
        };

        const loader = $loading.show(utils.configuracionLoading);
        try {
            const { data } = await authApi.get(
                `/roles/obtener-roles/${ nombre }`,
                cabecera()
            );
            loader.hide();

            if (data.ok) {
                respuesta.ok = true;
                respuesta.data = data.datos;
            } else {
                utils.mostrarMensaje({
                    descripcion: data.mensaje.descripcion,
                    tipoMensaje: data.mensaje.tipoMensaje
                });
            }
        } catch (error) {
            loader.hide();

            utils.mostrarMensajeErrorApi(error);
        }

        return respuesta;
    }

    const obtenerRol = async (id_rol: number) => {
        const respuesta = {
            ok: false,
            data: undefined as any,
            permisos: [] as any[],
        };

        const loader = $loading.show(utils.configuracionLoading);
        try {
            const { data } = await authApi.get(
                `/roles/obtener-rol/${ id_rol }`,
                cabecera()
            );
            loader.hide();

            if (data.ok) {
                respuesta.ok = true;
                respuesta.data = data.datos;
                respuesta.permisos = data.extraData;
            } else {
                utils.mostrarMensaje({
                    descripcion: data.mensaje.descripcion,
                    tipoMensaje: data.mensaje.tipoMensaje
                });
            }
        } catch (error) {
            loader.hide();

            utils.mostrarMensajeErrorApi(error);
        }

        return respuesta;
    }

    const obtenerModulos = async () => {
        const respuesta = {
            ok: false,
            data: undefined as any,
        };

        const loader = $loading.show(utils.configuracionLoading);
        try {
            const { data } = await authApi.get(
                `/roles/obtener-modulos`,
                cabecera()
            );
            loader.hide();

            if (data.ok) {
                respuesta.ok = true;
                respuesta.data = data.datos;
            }
        } catch (error) {
            loader.hide();

            utils.mostrarMensajeErrorApi(error);
        }

        return respuesta;
    }

    const grabarRol = async (rol: any) => {
        const respuesta = {
            ok: false,
            data: 0,
        };

        const loader = $loading.show(utils.configuracionLoading);
        try {
            const { data } = await authApi.post(
                '/roles/grabar-rol',
                rol,
                cabecera()
            );
            loader.hide();

            if (data.ok) {
                respuesta.data = data.datos;
                respuesta.ok = true;
            }
            utils.mostrarMensaje({
                descripcion: data.mensaje.descripcion,
                tipoMensaje: data.mensaje.tipoMensaje
            });
        } catch (error) {
            loader.hide();
            utils.mostrarMensajeErrorApi(error);
        }

        return respuesta;
    }

    const cambiarEstadoRol = async (id_rol: number, estado: boolean) => {
        const respuesta = {
            ok: false,
        };

        const loader = $loading.show(utils.configuracionLoading);
        try {
            const { data } = await authApi.post(
                '/roles/cambiar-estado-rol',
                { id_rol, estado },
                cabecera()
            );
            loader.hide();

            if (data.ok) {
                respuesta.ok = true;
            }
            utils.mostrarMensaje({
                descripcion: data.mensaje.descripcion,
                tipoMensaje: data.mensaje.tipoMensaje
            });
        } catch (error) {
            loader.hide();
            utils.mostrarMensajeErrorApi(error);
        }

        return respuesta;
    }

    return {
        obtenerRoles,
        obtenerRol,
        obtenerModulos,
        grabarRol,
        cambiarEstadoRol,
    }
};

export default useRoles;
